import PastUploads from "./PastUploads";
import OngoingUpload from "./OngoingUpload";
import Loader from "../../components/Loader";
import { Tabs, Tab } from "react-bootstrap";
import i18n from "../../constants/Strings";
import useBulkUploadViewController from "../../viewControllers/BulkUploadViewController";
import UploadCSV from "./UploadCSV";

const BulkUpload = () => {
  const {
    loading,
    saveStatus,
    selectedFile,
    setSelectedFile,
    fileName,
    setFileName,
    lastProcessedUpload,
    lastUploadStatus,
    pastUploads,
    uploadInitialInventoryFile,
    handleRetry,
    downloadFile,
    downloadSampleCSV
  } = useBulkUploadViewController();

  const text = {
    pageHeading: i18n.t("bulkUpload.pageHeading"),
    statusTabTitle: i18n.t("bulkUpload.statusTabTitle"),
    historyTabTitle: i18n.t("bulkUpload.historyTabTitle"),
    fileUnderProcessMessage: i18n.t("bulkUpload.fileUnderProcessingMessage"),
  };

  return (
    <>
      <div className="container-fluid">
        <div className="card-header py-4">
          <h6 className="m-0 font-weight-bold txt-primary">
            {text.pageHeading}
          </h6>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <Tabs defaultActiveKey="status" className="mb-3" fill>
            <Tab eventKey="status" title={text.statusTabTitle}>
              {lastUploadStatus == "PROCESSING" ? (
                <OngoingUpload
                  status={lastProcessedUpload}
                  message={text.fileUnderProcessMessage}
                />
              ) : (
                <UploadCSV
                  loading={loading}
                  fileName={fileName}
                  setFileName={setFileName}
                  saveStatus={saveStatus}
                  uploadFile={uploadInitialInventoryFile}
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                  downloadSampleCSV={downloadSampleCSV}
                />
              )}
            </Tab>
            <Tab eventKey="history" title={text.historyTabTitle}>
              {pastUploads && pastUploads.length === 0 ? (
                <p className="mt-5">No past uploads</p>
              ) : (
                <PastUploads
                  ongoingUploadStatus={lastUploadStatus}
                  pastUploads={pastUploads}
                  handleRetry={handleRetry}
                  handleDownloadFile={downloadFile}
                />
              )}
            </Tab>
          </Tabs>
        )}
      </div>
    </>
  );
};

export default BulkUpload;
